declare global {
  interface String {
    addImportantClass(): string
    shortText(length: number): string
    toPersian(): string
    toEnglish(): string
  }
  interface Number {
    digitNumber(length?: number): string
  }
  interface Number {
    currency(): string
  }
  interface Date {
    toShamsi(): string
  }
  interface Array<T> {
    distinct(property: string): Array<T>
  }
  interface Date {
    getFormattedTime(): string
  }
  interface Window {
    env: EnvironmentInterface
  }
}
interface EnvironmentInterface {
  APP_Domain: string
  APP_Rayteb_Domain: string
  App_BaseUrl: string
  App_Rayteb_Support: string
}
Date.prototype.getFormattedTime = function (): string {
  if (!this) return '';
  const timeComponents = [this.getHours(), this.getMinutes()];
  return timeComponents
    .map(component => {
      const pad = (component < 10) ? '0' : '';
      return pad + component;
    })
    .join(':').toString();
}
String.prototype.addImportantClass = function (): string {
  if (!this) return ''
  return this.split(' ')
    .map((n) => `!${n}`)
    .join(' ')
}

String.prototype.shortText = function (length: number): string {
  if (!this) return ''
  return this.length > length
    ? `...${this.substring(0, length)}`
    : this.toString()
}
String.prototype.toPersian = function (): string {
  if (!this) return ''
  return this.replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d])
}

String.prototype.toEnglish = function (): string {
  if (!this) return ''
  return this.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
}

Number.prototype.digitNumber = function (length?: number): string {
  if (!length) length = 3
  if (!this) return '0'
  return this.toFixed(length)
}
Number.prototype.currency = function (): string {
  return new Intl.NumberFormat('fa-IR', {
    style: 'currency',
    currency: 'IRR',
  }).format(this.valueOf())
}
Date.prototype.toShamsi = function (): string {
  if (!this) return ''
  return `${this.toLocaleString('fa', {
    year: 'numeric',
  })}/${this.toLocaleString('fa', {
    month: 'numeric',
  })}/${this.toLocaleString('fa', { day: 'numeric' })}`
}
Array.prototype.distinct = function <T>(property: string): Array<T> {
  return this.filter((item, index, arr) => {
    return arr.findIndex((n) => n[property] === item[property]) === index
  })
}

export { }
